
import Vue from "vue";
import Component from "vue-class-component";

/**
 * Component representing the website's navigation bar
 */
@Component
export default class AppNavBar extends Vue {
  /**
   * 👂 Handler for when the logo has been clicked
   */
  private onLogoClicked() {
    if (this.$store.state.authorization.isAuthorized) {
      this.$router.push("/my-portfolio");
    } else {
      window.location.href = "https://oneclick.fi";
    }
  }

  private get logoImage() {
    return require("@/assets/logos/ob/full-logo-" +
      (this.$vuetify.theme.dark ? "light" : "dark") +
      ".svg");
  }
}
